import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Home from './Home/Home';
import Counters from './Counters/Counters';
import VisaTimeline from './VisaTimeline/VisaTimeline';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/spire-wizard" element={<App />} />
          <Route path="/spire-wizard-mobile" element={<App />} />
          <Route path="/counters" element={<Counters />} />
          <Route path="/visa-timeline" element={<VisaTimeline />} />
        </Routes>
      </Router>
    </Provider>
  </React.StrictMode>
);
